import { attempts as attemptsApi } from '../../../services/api';
import { EvaluationResultData } from '../types';

export const evaluationService = {
  async getResults(attemptId: string, forceEval = false): Promise<EvaluationResultData> {
    const res = await (attemptsApi as any).getResults(attemptId, forceEval);
    if (!res.success) {
      throw new Error(res.error?.message || 'Failed to fetch evaluation results');
    }
    return res.data ?? res;
  },

  async getEvidence(attemptId: string): Promise<any> {
    const res = await attemptsApi.getEvidence(attemptId) as any;
    if (!res.success) {
      throw new Error(res.error?.message || 'Failed to fetch multimodal evidence');
    }
    return res.data ?? res;
  },
};
